import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "notice-panel"
};
var _hoisted_2 = {
  class: "main"
};
var _hoisted_3 = {
  key: 0,
  class: "container"
};
var _hoisted_4 = {
  class: "title"
};
var _hoisted_5 = ["innerHTML"];
import SideBar from '../common/SideBar';
import Empty from '../common/Empty';
import Editor from './Editor';

/* 工具 */
import { reactive, inject, computed, onMounted } from 'vue';
import { DialogPlugin, MessagePlugin } from 'tdesign-vue-next';
import { operationRecord } from '../common/common';
import { LEFT_BAR_MAP } from '../../const';
import { debounce } from '@/util/index';

/* api */
import { addNotice, getNoticeList, getRecentNotice, deleteNotice } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'index',
  setup: function setup(__props) {
    /* 组件 */
    var state = reactive({
      dialogShow: false,
      title: '',
      content: '',
      noticeId: '',
      noticeList: [],
      formData: {
        title: '',
        content: ''
      }
    });
    var discussId = inject('discussId');

    /* 计算属性 */
    // 面板是否显示公告
    var isShowNotice = computed(function () {
      return state.title || state.content;
    });

    /* 事件 */
    // 侧边栏点击
    var sideBarChange = function sideBarChange(item) {
      if (item.click === 'noticePub') {
        state.dialogShow = true;
      }
    };

    // 获取公告列表
    var getList = function getList() {
      getNoticeList(discussId.value).then(function (res) {
        if (res.data.code === 0) {
          var list = res.data.data || [];
          var actItem = list.find(function (e) {
            return e.id === state.noticeId;
          });
          var actIndex = list.findIndex(function (e) {
            return e.id === state.noticeId;
          });
          if (actIndex !== -1) {
            list.splice(actIndex, 1);
            list.unshift(actItem);
          }
          state.noticeList = list.map(function (e) {
            return _objectSpread(_objectSpread({}, e), {}, {
              id: e.id,
              name: e.title
            });
          });
        }
      });
    };

    // 切换公告
    var noticeChange = function noticeChange(data) {
      state.noticeId = (data === null || data === void 0 ? void 0 : data.id) || '';
      state.title = (data === null || data === void 0 ? void 0 : data.title) || '';
      state.content = (data === null || data === void 0 ? void 0 : data.content) || '';
      operationRecord(discussId.value, '查看公告');
    };

    // 删除公告
    var noticeDelete = function noticeDelete(data) {
      var dialog = DialogPlugin({
        header: '删除公告',
        body: '是否删除该公告',
        theme: 'danger',
        cancelBtn: '取消',
        confirmBtn: {
          content: '确认',
          theme: 'danger'
        },
        onConfirm: function onConfirm() {
          deleteNotice(discussId.value, data.id).then(function (res) {
            if (res.data.code === 0) {
              MessagePlugin.success('删除成功！');
              state.noticeList = [];
              getNotice();
              dialog.destroy();
            }
          });
        }
      });
    };

    // 关闭弹窗
    var onClose = function onClose() {
      state.formData.title = '';
      state.formData.content = '';
      state.dialogShow = false;
    };

    // 去除html标签
    var stripHtmlTags = function stripHtmlTags(str) {
      return str.replace(/<[^>]*>?/gm, '');
    };

    // 弹窗确定
    var onConfirm = debounce(function () {
      if (!state.formData.title) {
        MessagePlugin.warning('请输入公告标题！');
      } else if (!state.formData.content) {
        MessagePlugin.warning('请输入公告内容！');
      } else if (stripHtmlTags(state.formData.content).length > 2000) {
        MessagePlugin.warning('公告内容最多2000字！');
      } else {
        var data = {
          discussId: discussId.value,
          title: state.formData.title,
          content: state.formData.content
        };
        addNotice(data).then(function (res) {
          if (res.data.code === 0) {
            MessagePlugin.success('添加成功！');
            var notice = {
              id: res.data.data,
              title: data.title,
              content: data.content
            };
            noticeChange(notice);
            onClose();
          }
        });
      }
    });

    // 获取教研第一个公告
    var getNotice = function getNotice() {
      getRecentNotice(discussId.value).then(function (res) {
        if (res.data.code === 0) {
          noticeChange(res.data.data);
        }
      });
    };

    /* 钩子 */
    onMounted(function () {
      getNotice();
    });
    return function (_ctx, _cache) {
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(SideBar), {
        barList: _unref(LEFT_BAR_MAP)['notice'],
        hoverId: state.noticeId,
        hoverList: state.noticeList,
        onTabChange: sideBarChange,
        onHoverEnter: getList,
        onHoverChange: noticeChange,
        onHoverDelete: noticeDelete
      }, null, 8, ["barList", "hoverId", "hoverList"]), _createElementVNode("div", _hoisted_2, [isShowNotice.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(state.title), 1), _createElementVNode("p", {
        class: "content",
        innerHTML: state.content
      }, null, 8, _hoisted_5)])) : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        name: "notice"
      }))]), _createVNode(_component_t_dialog, {
        visible: state.dialogShow,
        "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
          return state.dialogShow = $event;
        }),
        header: "发布公告",
        width: "839px",
        placement: "center",
        onClose: onClose,
        onConfirm: _unref(onConfirm)
      }, {
        default: _withCtx(function () {
          return [state.dialogShow ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_withDirectives(_createElementVNode("input", {
            class: "ipt",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return state.formData.title = $event;
            }),
            placeholder: "请输入公告标题",
            maxlength: "15"
          }, null, 512), [[_vModelText, state.formData.title]]), _createVNode(_unref(Editor), {
            value: state.formData.content,
            "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
              return state.formData.content = $event;
            }),
            height: "60vh",
            maxlength: "2000"
          }, null, 8, ["value"])], 64)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible", "onConfirm"])]);
    };
  }
};